import { styled } from '@mui/material/styles';
import { PlusIcon } from '@phosphor-icons/react/Plus';

export const StyledBulkInputPlusSignIcon = styled(PlusIcon)`
  margin-right: ${({ theme }) => theme.spacing(2)};
`;
